import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, renderList as _renderList, vShow as _vShow, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  style: {"width":"400px"},
  class: "d-flex justify-center"
}
const _hoisted_2 = {
  style: {"width":"400px"},
  class: "d-flex justify-center"
}
const _hoisted_3 = { style: {"height":"calc(100vh - 157px)","overflow-y":"auto","border-top-left-radius":"25px","border-top-right-radius":"25px"} }
const _hoisted_4 = {
  style: {"background-color":"white","border-radius":"25px"},
  class: "pa-4"
}
const _hoisted_5 = {
  style: {"background-color":"white","border-radius":"25px"},
  class: "pa-4"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { style: {"font-weight":"bold","border-right":"1px solid #dddddd"} }
const _hoisted_16 = {
  key: 0,
  style: {"border-right":"1px solid #dddddd"},
  class: "text-right grey lighten-4"
}
const _hoisted_17 = {
  key: 1,
  class: "text-right grey lighten-4",
  style: {"border-right":"1px solid #dddddd"}
}
const _hoisted_18 = {
  key: 2,
  class: "text-right grey lighten-4"
}
const _hoisted_19 = {
  key: 3,
  class: "text-right grey lighten-4"
}
const _hoisted_20 = {
  key: 4,
  class: "text-right grey lighten-4"
}
const _hoisted_21 = {
  key: 5,
  class: "text-right grey lighten-4"
}
const _hoisted_22 = {
  key: 6,
  style: {"border-right":"1px solid #dddddd"},
  class: "text-right grey lighten-4"
}
const _hoisted_23 = {
  key: 7,
  class: "text-right grey lighten-4",
  style: {"border-right":"1px solid #dddddd"}
}
const _hoisted_24 = {
  style: {"font-weight":"bold","border-right":"1px solid #dddddd"},
  class: "text-right"
}
const _hoisted_25 = { class: "text-right grey lighten-4" }
const _hoisted_26 = { class: "text-right grey lighten-4" }
const _hoisted_27 = { class: "text-right grey lighten-4" }
const _hoisted_28 = {
  key: 0,
  class: "text-right grey lighten-4"
}
const _hoisted_29 = {
  key: 1,
  class: "text-right grey lighten-4"
}
const _hoisted_30 = {
  key: 2,
  class: "text-right grey lighten-4"
}
const _hoisted_31 = {
  key: 3,
  class: "text-right grey lighten-4"
}
const _hoisted_32 = {
  key: 4,
  class: "text-right grey lighten-4"
}
const _hoisted_33 = {
  key: 5,
  class: "text-right grey lighten-4"
}
const _hoisted_34 = {
  key: 6,
  class: "text-right grey lighten-4",
  style: {"border-right":"1px solid #dddddd"}
}
const _hoisted_35 = {
  key: 7,
  class: "text-right grey lighten-4",
  style: {"border-right":"1px solid #dddddd"}
}
const _hoisted_36 = {
  key: 2,
  class: "text-right",
  style: {"font-weight":"bold"}
}
const _hoisted_37 = {
  key: 3,
  class: "text-right"
}
const _hoisted_38 = {
  key: 4,
  class: "text-center",
  style: {"font-weight":"bold"}
}
const _hoisted_39 = {
  key: 5,
  class: "text-center"
}
const _hoisted_40 = {
  key: 6,
  class: "text-center",
  style: {"font-weight":"bold","border-right":"1px solid #dddddd"}
}
const _hoisted_41 = {
  key: 7,
  class: "text-center",
  style: {"font-weight":"bold","border-right":"1px solid #dddddd"}
}
const _hoisted_42 = {
  key: 8,
  class: "text-center",
  style: {"font-weight":"bold","border-right":"1px solid #dddddd"}
}
const _hoisted_43 = {
  key: 9,
  class: "text-center",
  style: {"font-weight":"bold"}
}
const _hoisted_44 = { key: 10 }
const _hoisted_45 = {
  key: 11,
  class: "text-center",
  style: {"font-weight":"bold","border-right":"1px solid #dddddd"}
}
const _hoisted_46 = {
  key: 12,
  class: "text-center",
  style: {"font-weight":"bold","border-right":"1px solid #dddddd"}
}
const _hoisted_47 = {
  key: 13,
  class: "text-center",
  style: {"font-weight":"bold","border-right":"1px solid #dddddd"}
}
const _hoisted_48 = {
  style: {"border-left":"1px solid #dddddd","width":"170px"},
  class: "text-center"
}
const _hoisted_49 = {
  class: "text-center",
  style: {"border-left":"1px #ededed solid"}
}
const _hoisted_50 = ["colspan"]
const _hoisted_51 = { style: {"background-color":"white","border-radius":"25px"} }
const _hoisted_52 = {
  key: 0,
  class: "text-center"
}
const _hoisted_53 = { key: 1 }
const _hoisted_54 = { key: 2 }
const _hoisted_55 = { key: 3 }
const _hoisted_56 = {
  key: 2,
  class: "text-right"
}
const _hoisted_57 = { class: "text-center pl-2 py-0" }
const _hoisted_58 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_59 = {
  key: 1,
  style: {"color":"red"}
}
const _hoisted_60 = {
  key: 0,
  style: {"font-weight":"bold","color":"red"},
  class: "text-left"
}
const _hoisted_61 = {
  key: 1,
  style: {"font-weight":"bold"},
  class: "text-left"
}
const _hoisted_62 = {
  style: {"font-weight":"bold"},
  class: "text-right"
}
const _hoisted_63 = {
  key: 2,
  style: {"font-weight":"bold","color":"red"},
  class: "text-right"
}
const _hoisted_64 = {
  key: 3,
  style: {"font-weight":"bold"},
  class: "text-right"
}
const _hoisted_65 = {
  key: 4,
  style: {"font-weight":"bold"},
  class: "text-right"
}
const _hoisted_66 = {
  key: 5,
  style: {"font-weight":"bold"},
  class: "text-right"
}
const _hoisted_67 = {
  key: 6,
  style: {"font-weight":"bold"},
  class: "text-right"
}
const _hoisted_68 = {
  key: 7,
  style: {"font-weight":"bold"},
  class: "text-right secondary--text"
}
const _hoisted_69 = {
  key: 8,
  style: {"font-weight":"bold"},
  class: "text-right"
}
const _hoisted_70 = {
  key: 9,
  style: {"font-weight":"bold"},
  class: "text-right secondary--text"
}
const _hoisted_71 = {
  key: 10,
  style: {"font-weight":"bold"},
  class: "text-right"
}
const _hoisted_72 = { style: {"font-weight":"bold"} }
const _hoisted_73 = { style: {"text-align":"right"} }
const _hoisted_74 = { style: {"text-align":"right"} }
const _hoisted_75 = { style: {"text-align":"right"} }
const _hoisted_76 = {
  key: 0,
  style: {"text-align":"right"}
}
const _hoisted_77 = {
  key: 1,
  style: {"text-align":"right"}
}
const _hoisted_78 = {
  key: 2,
  style: {"text-align":"right"}
}
const _hoisted_79 = {
  key: 3,
  style: {"text-align":"right"}
}
const _hoisted_80 = {
  key: 4,
  style: {"text-align":"right"}
}
const _hoisted_81 = {
  style: {"background-color":"white","border-radius":"25px"},
  class: "pa-4"
}
const _hoisted_82 = {
  key: 0,
  class: "text-center"
}
const _hoisted_83 = {
  key: 1,
  class: "text-center"
}
const _hoisted_84 = {
  key: 2,
  class: "text-left"
}
const _hoisted_85 = {
  key: 3,
  class: "text-left"
}
const _hoisted_86 = {
  key: 4,
  class: "text-left"
}
const _hoisted_87 = {
  key: 5,
  class: "text-left"
}
const _hoisted_88 = {
  key: 6,
  class: "text-right"
}
const _hoisted_89 = {
  key: 7,
  class: "text-right"
}
const _hoisted_90 = {
  key: 8,
  class: "text-right"
}
const _hoisted_91 = {
  key: 9,
  class: "text-right"
}
const _hoisted_92 = {
  key: 10,
  class: "text-right"
}
const _hoisted_93 = {
  key: 11,
  class: "text-right"
}
const _hoisted_94 = {
  key: 12,
  class: "text-center"
}
const _hoisted_95 = {
  key: 13,
  class: "text-center"
}
const _hoisted_96 = { class: "text-center pl-2 py-0" }
const _hoisted_97 = {
  style: {"background-color":"white","border-radius":"25px"},
  class: "pa-4"
}
const _hoisted_98 = {
  key: 0,
  class: "text-center"
}
const _hoisted_99 = { key: 1 }
const _hoisted_100 = { key: 2 }
const _hoisted_101 = { key: 3 }
const _hoisted_102 = { key: 4 }
const _hoisted_103 = {
  key: 5,
  class: "text-right"
}
const _hoisted_104 = {
  key: 6,
  class: "text-right"
}
const _hoisted_105 = {
  key: 7,
  class: "text-right"
}
const _hoisted_106 = { class: "text-center pl-2 py-0" }
const _hoisted_107 = { style: {"font-weight":"bold"} }
const _hoisted_108 = { style: {"text-align":"right","font-weight":"bold"} }
const _hoisted_109 = {
  style: {"background-color":"white","border-radius":"25px"},
  class: "pa-4"
}
const _hoisted_110 = {
  key: 0,
  class: "text-left"
}
const _hoisted_111 = { key: 1 }
const _hoisted_112 = { key: 2 }
const _hoisted_113 = { key: 3 }
const _hoisted_114 = {
  key: 4,
  class: "text-right"
}
const _hoisted_115 = { key: 5 }
const _hoisted_116 = {
  key: 6,
  class: "text-right"
}
const _hoisted_117 = { key: 7 }
const _hoisted_118 = {
  key: 8,
  class: "text-right"
}
const _hoisted_119 = { key: 9 }
const _hoisted_120 = { class: "text-center pl-2 py-0" }
const _hoisted_121 = { "no-gutters": "" }
const _hoisted_122 = { class: "text-uppercase pb-1" }
const _hoisted_123 = { class: "mb-0" }
const _hoisted_124 = {
  key: 0,
  class: "pl-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn_prev = _resolveComponent("v-btn-prev")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_oss_text_field = _resolveComponent("oss-text-field")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_GetEmptyDocumentsTable = _resolveComponent("GetEmptyDocumentsTable")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_AuditConnectedAcrDocuments = _resolveComponent("AuditConnectedAcrDocuments")!
  const _component_AuditConnectedAcrResults = _resolveComponent("AuditConnectedAcrResults")!
  const _component_GeneralLedger = _resolveComponent("GeneralLedger")!
  const _component_UsersActivitiesHistory = _resolveComponent("UsersActivitiesHistory")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_Chat = _resolveComponent("Chat")!
  const _component_AuditCheckDocumentsManager = _resolveComponent("AuditCheckDocumentsManager")!
  const _component_v_container = _resolveComponent("v-container")!
  const _directive_props = _resolveDirective("props")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { class: "d-flex justify-space-between mb-1" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "6",
            class: "d-flex flex-column"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { "no-gutters": "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "1",
                    class: "d-flex align-center justify-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn_back, {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'auditReport' })))
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "11" }, {
                    default: _withCtx(() => _cache[44] || (_cache[44] = [
                      _createElementVNode("h2", null, "Provisions pour clients douteux et créances irrécouvrables", -1)
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, { "no-gutters": "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "1" }),
                  _createVNode(_component_v_col, { cols: "10" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(`Statut : ${_ctx.checkStatus}`), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "6" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "d-flex justify-end align-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_tooltip, { location: "bottom" }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn, _mergeProps({
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogAuditCheckDocumentsManager = true))
                      }, props, {
                        size: "x-small",
                        icon: "$oss-upload"
                      }), null, 16)
                    ]),
                    default: _withCtx(() => [
                      _cache[45] || (_cache[45] = _createElementVNode("span", null, "Lier un document", -1))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_tooltip, { location: "bottom" }, {
                    activator: _withCtx(({ props }) => [
                      _withDirectives(_createVNode(_component_v_btn, {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openChat = !_ctx.openChat)),
                        size: "x-small",
                        icon: "$oss-chat"
                      }, null, 512), [
                        [_directive_props, props]
                      ])
                    ]),
                    default: _withCtx(() => [
                      _cache[46] || (_cache[46] = _createElementVNode("span", null, "Message", -1))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, {
                    disabled: 
                            _ctx.closedPeriod || _ctx.validated || _ctx.loading || _ctx.dataLoading || !_ctx.accountingPeriod
                        ,
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.storeComments())),
                    size: "small",
                    class: "mx-1"
                  }, {
                    default: _withCtx(() => _cache[47] || (_cache[47] = [
                      _createTextVNode(" Enregistrer ")
                    ])),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_v_btn, {
                    disabled: 
                            _ctx.disabledBtnGlobalValidation ||
                            _ctx.loading ||
                            _ctx.dataLoading ||
                            !_ctx.accountingPeriod
                        ,
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.validateFunction())),
                    size: "small",
                    class: "mx-1"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.validated ? "Invalider" : "Valider"), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  (_ctx.isEnableReview)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _cache[48] || (_cache[48] = _createElementVNode("div", { style: {"border-right":"2px solid black","width":"2px","height":"25px","margin":"0 4px"} }, null, -1)),
                        _createVNode(_component_v_icon, {
                          disabled: 
                                _ctx.reviewed === 1 ||
                                !_ctx.isEnableReview ||
                                !_ctx.validated ||
                                _ctx.loading ||
                                _ctx.dataLoading
                            ,
                          size: "small",
                          icon: "$fa-thumbs-up",
                          color: "primary",
                          class: "mx-1",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => {
                                _ctx.reviewed = 1;
                                _ctx.storeComments('REVIEW');
                            })
                        }, null, 8, ["disabled"]),
                        _createVNode(_component_v_icon, {
                          disabled: 
                                _ctx.reviewed === -1 ||
                                !_ctx.isEnableReview ||
                                !_ctx.validated ||
                                _ctx.loading ||
                                _ctx.dataLoading
                            ,
                          size: "small",
                          icon: "$fa-thumbs-down",
                          color: "primary",
                          class: "mx-1",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => {
                                _ctx.reviewed = -1;
                                _ctx.storeComments('REVIEW');
                            })
                        }, null, 8, ["disabled"]),
                        _cache[49] || (_cache[49] = _createElementVNode("div", { style: {"border-right":"2px solid black","width":"1px","height":"25px","margin":"0 4px"} }, null, -1))
                      ], 64))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_tooltip, { location: "bottom" }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn_prev, _mergeProps(props, {
                        disabled: !_ctx.previousControl,
                        onClick: _cache[7] || (_cache[7] = ($event: any) => {
                                    _ctx.reviewed = 0;
                                    _ctx.openChat = false;
                                    _ctx.goToPreviousControl();
                                })
                      }), null, 16, ["disabled"])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, " Contrôle précédent : " + _toDisplayString(_ctx.previousControl && _ctx.previousControl.title
                                    ? _ctx.previousControl.title
                                    : ""), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_tooltip, { location: "bottom" }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn_next, _mergeProps(props, {
                        onClick: _cache[8] || (_cache[8] = ($event: any) => {
                                    _ctx.reviewed = 0;
                                    _ctx.openChat = false;
                                    _ctx.goToNextControl();
                                }),
                        disabled: !_ctx.nextControl
                      }), null, 16, ["disabled"])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, " Contrôle suivant : " + _toDisplayString(_ctx.nextControl && _ctx.nextControl.title ? _ctx.nextControl.title : ""), 1)
                    ]),
                    _: 1
                  }),
                  _cache[52] || (_cache[52] = _createElementVNode("div", { style: {"border-right":"2px solid black","width":"1px","height":"25px","margin":"0 4px"} }, null, -1)),
                  _createVNode(_component_v_menu, { "offset-y": "" }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn_icon, _mergeProps({ icon: "$dots_vertical" }, props, {
                        class: "mx-1",
                        color: "secondary"
                      }), null, 16)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list, { nav: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item, {
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.displayActivityDialog = true))
                          }, {
                            append: _withCtx(() => [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => _cache[51] || (_cache[51] = [
                                  _createTextVNode("$oss-activity")
                                ])),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => _cache[50] || (_cache[50] = [
                                  _createTextVNode("Afficher l'activité")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.loading || _ctx.dataLoading)
          ? (_openBlock(), _createBlock(_component_v_card, {
              key: 0,
              elevation: "0",
              style: {"background-color":"#ffffff","border-radius":"25px","margin-top":"10px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "pa-4 d-flex justify-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_progress_circular, {
                      indeterminate: "",
                      class: "mr-3"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : (!_ctx.accountingPeriod)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 1,
                "no-gutters": "",
                class: "d-flex flex-column justify-center align-center mb-3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    class: "mr-2 mb-1",
                    size: "large"
                  }, {
                    default: _withCtx(() => _cache[53] || (_cache[53] = [
                      _createTextVNode(" $oss-warning ")
                    ])),
                    _: 1
                  }),
                  _cache[54] || (_cache[54] = _createElementVNode("h3", null, "Aucune période sélectionnée", -1))
                ]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                (_ctx.accountingPeriod && _ctx.accountingPeriod.closed)
                  ? (_openBlock(), _createBlock(_component_v_row, {
                      key: 0,
                      "no-gutters": "",
                      class: "d-flex flex-column justify-center align-center mb-3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          class: "mr-2 mb-1",
                          size: "large"
                        }, {
                          default: _withCtx(() => _cache[55] || (_cache[55] = [
                            _createTextVNode(" $oss-warning ")
                          ])),
                          _: 1
                        }),
                        _cache[56] || (_cache[56] = _createElementVNode("h3", null, "Période clôturée", -1))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!_ctx.customers || !_ctx.customers.length)
                  ? (_openBlock(), _createBlock(_component_v_card, {
                      key: 1,
                      elevation: "0",
                      class: "px-4 my-4",
                      style: {"background-color":"white","border-radius":"25px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_text, { class: "px-0" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_4, [
                              _createVNode(_component_v_row, { class: "px-5 py-3" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { cols: "auto" }, {
                                    default: _withCtx(() => _cache[57] || (_cache[57] = [
                                      _createElementVNode("h3", null, "Pas de créances en attente de paiement", -1)
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_v_card, {
                      key: 2,
                      elevation: "0",
                      class: "px-4 my-4",
                      style: {"background-color":"white","border-radius":"25px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_text, { class: "px-0" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_5, [
                              _createVNode(_component_v_row, { class: "px-5 py-3" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { cols: "auto" }, {
                                    default: _withCtx(() => [
                                      (_ctx.resume && _ctx.resume.resumeDate)
                                        ? (_openBlock(), _createElementBlock("h3", _hoisted_6, " Total créances calculées au : " + _toDisplayString(_ctx.resume.resumeDate), 1))
                                        : (_openBlock(), _createElementBlock("h3", _hoisted_7, "Total créances :"))
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, null, {
                                    default: _withCtx(() => [
                                      (_ctx.resume.grossAmountSigned)
                                        ? (_openBlock(), _createElementBlock("h3", _hoisted_8, " T.T.C. : " + _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.resume.grossAmountSigned, {
                                                currency: "",
                                                DC: true,
                                            })), 1))
                                        : (_openBlock(), _createElementBlock("h3", _hoisted_9, "T.T.C. : -"))
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, null, {
                                    default: _withCtx(() => [
                                      (_ctx.resume.netAmountSigned)
                                        ? (_openBlock(), _createElementBlock("h3", _hoisted_10, _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.resume.netAmountSigned, {
                                                currency: "",
                                                DC: true,
                                            })) + " HT ", 1))
                                        : (_openBlock(), _createElementBlock("h3", _hoisted_11, "- HT"))
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, null, {
                                    default: _withCtx(() => [
                                      (_ctx.resume.vatAmountSigned)
                                        ? (_openBlock(), _createElementBlock("h3", _hoisted_12, " T.V.A. : " + _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.resume.vatAmountSigned, {
                                                currency: "",
                                                DC: true,
                                            })), 1))
                                        : (_openBlock(), _createElementBlock("h3", _hoisted_13, "T.V.A. : -"))
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "1",
                                    class: "d-flex align-center"
                                  }, {
                                    default: _withCtx(() => _cache[58] || (_cache[58] = [
                                      _createTextVNode("Afficher :")
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, { cols: "auto" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_switch, {
                                        modelValue: _ctx.switchPrevious,
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.switchPrevious) = $event)),
                                        label: `Créances et AAE`,
                                        style: {},
                                        class: "ml-2",
                                        size: "x-small"
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, { cols: "auto" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_switch, {
                                        modelValue: _ctx.switchReceivableAgeing,
                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.switchReceivableAgeing) = $event)),
                                        label: `Balance âgée`,
                                        style: {},
                                        class: "ml-2",
                                        size: "x-small"
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, { cols: "auto" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_switch, {
                                        modelValue: _ctx.switchValidated,
                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.switchValidated) = $event)),
                                        label: `Validés`,
                                        style: {},
                                        class: "ml-2",
                                        size: "x-small"
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, { cols: "auto" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_switch, {
                                        modelValue: _ctx.switchIgnored,
                                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.switchIgnored) = $event)),
                                        label: `Ignorés`,
                                        style: {},
                                        class: "ml-2"
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, { cols: "auto" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_switch, {
                                        modelValue: _ctx.switchUnrecoverableLoss,
                                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.switchUnrecoverableLoss) = $event)),
                                        label: `Totalité de la créance passée en perte`,
                                        style: {},
                                        class: "ml-2"
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_data_table, {
                                headers: _ctx.computedHeaders,
                                items: _ctx.customers,
                                expanded: _ctx.expanded,
                                "item-key": "customer.id",
                                "show-expand": "",
                                "sort-by": [{ key: 'customer.name', order: 'asc' }],
                                "sort-desc": false,
                                loading: _ctx.loading,
                                class: "table",
                                style: {"border":"1px #ededed solid"}
                              }, {
                                "no-data": _withCtx(() => _cache[59] || (_cache[59] = [
                                  _createTextVNode("Aucune facture échue")
                                ])),
                                item: _withCtx((props) => [
                                  (_ctx.showRow(props.item))
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                                        _createElementVNode("td", _hoisted_15, _toDisplayString(props.item.customer.name), 1),
                                        (_ctx.switchPrevious)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              (
                                                    props.item
                                                        .creditNotesCumulatedGrossAmountSigned &&
                                                    props.item.existingCreditNotes
                                                )
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_16, [
                                                    _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                        props.item
                                                            .creditNotesCumulatedGrossAmountSigned,
                                                        undefined,
                                                    )) + " ", 1),
                                                    _createVNode(_component_v_btn_icon, {
                                                      icon: "$remove_red_eye",
                                                      onClick: ($event: any) => (
                                                        _ctx.openCreditNotesList(
                                                            props.item.existingCreditNotes,
                                                            props.item.customer,
                                                        )
                                                    ),
                                                      size: "x-small"
                                                    }, null, 8, ["onClick"])
                                                  ]))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_17, " - ")),
                                              (props.item.sales.netAmountSigned)
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_18, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                        props.item.sales.netAmountSigned,
                                                    )), 1))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_19, _toDisplayString(_ctx.newCommonFormatCurrency(0, undefined)), 1)),
                                              (props.item.sales.vatAmountSigned)
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_20, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                        props.item.sales.vatAmountSigned,
                                                    )), 1))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_21, _toDisplayString(_ctx.newCommonFormatCurrency(0, undefined)), 1)),
                                              (
                                                    props.item.sales.grossAmountSigned &&
                                                    props.item.sales.documents
                                                )
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_22, [
                                                    _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                        props.item.sales.grossAmountSigned,
                                                        undefined,
                                                    )) + " ", 1),
                                                    _createVNode(_component_v_btn_icon, {
                                                      icon: "$remove_red_eye",
                                                      onClick: ($event: any) => (
                                                        _ctx.openPeriodDocuments(
                                                            props.item.sales,
                                                            ' : toutes périodes',
                                                            props.item.customer,
                                                        )
                                                    ),
                                                      size: "x-small"
                                                    }, null, 8, ["onClick"])
                                                  ]))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_23, _toDisplayString(_ctx.newCommonFormatCurrency(0, undefined)), 1))
                                            ], 64))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("td", _hoisted_24, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                    props.item.basisGrossAmountSigned,
                                                    undefined,
                                                )), 1),
                                        (_ctx.switchReceivableAgeing)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                              _createElementVNode("td", _hoisted_25, [
                                                _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                        props.item.period31.grossAmountSigned,
                                                        undefined,
                                                    )) + " ", 1),
                                                _createVNode(_component_v_btn_icon, {
                                                  icon: "$remove_red_eye",
                                                  onClick: ($event: any) => (
                                                        _ctx.openPeriodDocuments(
                                                            props.item.period31,
                                                            ' - de 31 jrs',
                                                            props.item.customer,
                                                        )
                                                    ),
                                                  size: "x-small"
                                                }, null, 8, ["onClick"])
                                              ]),
                                              _createElementVNode("td", _hoisted_26, [
                                                _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                        props.item.period60.grossAmountSigned,
                                                        undefined,
                                                    )) + " ", 1),
                                                _createVNode(_component_v_btn_icon, {
                                                  icon: "$remove_red_eye",
                                                  onClick: ($event: any) => (
                                                        _ctx.openPeriodDocuments(
                                                            props.item.period60,
                                                            ' - de 60 jrs',
                                                            props.item.customer,
                                                        )
                                                    ),
                                                  size: "x-small"
                                                }, null, 8, ["onClick"])
                                              ]),
                                              _createElementVNode("td", _hoisted_27, [
                                                _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                        props.item.period90.grossAmountSigned,
                                                        undefined,
                                                    )) + " ", 1),
                                                _createVNode(_component_v_btn_icon, {
                                                  icon: "$remove_red_eye",
                                                  onClick: ($event: any) => (
                                                        _ctx.openPeriodDocuments(
                                                            props.item.period90,
                                                            ' - de 90 jrs',
                                                            props.item.customer,
                                                        )
                                                    ),
                                                  size: "x-small"
                                                }, null, 8, ["onClick"])
                                              ]),
                                              (
                                                    props.item.period120 &&
                                                    props.item.period120.grossAmountSigned
                                                )
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_28, [
                                                    _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                        props.item.period120.grossAmountSigned,
                                                        undefined,
                                                    )) + " ", 1),
                                                    _createVNode(_component_v_btn_icon, {
                                                      icon: "$remove_red_eye",
                                                      onClick: ($event: any) => (
                                                        _ctx.openPeriodDocuments(
                                                            props.item.period120,
                                                            ' - de 120 jrs',
                                                            props.item.customer,
                                                        )
                                                    ),
                                                      size: "x-small"
                                                    }, null, 8, ["onClick"])
                                                  ]))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_29, _toDisplayString(_ctx.newCommonFormatCurrency(0, undefined)), 1)),
                                              (
                                                    props.item.period180 &&
                                                    props.item.period180.grossAmountSigned
                                                )
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_30, [
                                                    _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                        props.item.period180.grossAmountSigned,
                                                        undefined,
                                                    )) + " ", 1),
                                                    _createVNode(_component_v_btn_icon, {
                                                      icon: "$remove_red_eye",
                                                      onClick: ($event: any) => (
                                                        _ctx.openPeriodDocuments(
                                                            props.item.period180,
                                                            ' - de 180 jrs',
                                                            props.item.customer,
                                                        )
                                                    ),
                                                      size: "x-small"
                                                    }, null, 8, ["onClick"])
                                                  ]))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_31, _toDisplayString(_ctx.newCommonFormatCurrency(0, undefined)), 1)),
                                              (
                                                    props.item.period365 &&
                                                    props.item.period365.grossAmountSigned
                                                )
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_32, [
                                                    _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                        props.item.period365.grossAmountSigned,
                                                        undefined,
                                                    )) + " ", 1),
                                                    _createVNode(_component_v_btn_icon, {
                                                      icon: "$remove_red_eye",
                                                      onClick: ($event: any) => (
                                                        _ctx.openPeriodDocuments(
                                                            props.item.period365,
                                                            ' - de 365 jrs',
                                                            props.item.customer,
                                                        )
                                                    ),
                                                      size: "x-small"
                                                    }, null, 8, ["onClick"])
                                                  ]))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_33, _toDisplayString(_ctx.newCommonFormatCurrency(0, undefined)), 1)),
                                              (
                                                    props.item.periodMore &&
                                                    props.item.periodMore.grossAmountSigned
                                                )
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_34, [
                                                    _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                        props.item.periodMore.grossAmountSigned,
                                                        undefined,
                                                    )) + " ", 1),
                                                    _createVNode(_component_v_btn_icon, {
                                                      icon: "$remove_red_eye",
                                                      onClick: ($event: any) => (
                                                        _ctx.openPeriodDocuments(
                                                            props.item.periodMore,
                                                            ' + de 365 jrs',
                                                            props.item.customer,
                                                        )
                                                    ),
                                                      size: "x-small"
                                                    }, null, 8, ["onClick"])
                                                  ]))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_35, _toDisplayString(_ctx.newCommonFormatCurrency(0, undefined)), 1))
                                            ], 64))
                                          : _createCommentVNode("", true),
                                        (
                                                props.item.doubtfulls &&
                                                props.item.doubtfulls.signedAmounts &&
                                                props.item.doubtfulls.signedAmounts.length &&
                                                props.item.doubtfulls.documents
                                            )
                                          ? (_openBlock(), _createElementBlock("td", _hoisted_36, [
                                              _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                    -props.item.doubtfulls.cumulated4SignedAmount,
                                                    undefined,
                                                )) + " ", 1),
                                              _createVNode(_component_v_btn_icon, {
                                                icon: "$remove_red_eye",
                                                onClick: ($event: any) => (
                                                    _ctx.openProvisionsList(
                                                        props.item.doubtfulls.documents,
                                                        props.item.customer,
                                                    )
                                                ),
                                                size: "x-small"
                                              }, null, 8, ["onClick"])
                                            ]))
                                          : (_openBlock(), _createElementBlock("td", _hoisted_37, _toDisplayString(_ctx.newCommonFormatCurrency(0, undefined)), 1)),
                                        (
                                                props.item.doubtfulls.cumulated4SignedAmount &&
                                                props.item.basisNetAmountSigned
                                            )
                                          ? (_openBlock(), _createElementBlock("td", _hoisted_38, _toDisplayString((
                                                    (props.item.doubtfulls.cumulated4SignedAmount *
                                                        100) /
                                                    props.item.basisNetAmountSigned
                                                ).toFixed(2)) + " % ", 1))
                                          : (_openBlock(), _createElementBlock("td", _hoisted_39, "-")),
                                        (
                                                _ctx.accountingPeriod.closed ||
                                                props.item.validated ||
                                                props.item.ignored
                                            )
                                          ? (_openBlock(), _createElementBlock("td", _hoisted_40, [
                                              _createVNode(_component_v_btn_icon, {
                                                icon: "$spellcheck",
                                                elevation: "0",
                                                disabled: "",
                                                size: "x-small"
                                              })
                                            ]))
                                          : (!_ctx.showProvision(props.item))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_41, [
                                                _createVNode(_component_v_tooltip, {
                                                  disabled: _ctx.valid,
                                                  location: "bottom"
                                                }, {
                                                  activator: _withCtx(({ props }) => [
                                                    _createElementVNode("div", _mergeProps(props, { class: "d-inline-block" }), [
                                                      _createVNode(_component_v_btn_icon, {
                                                        icon: "$spellcheck",
                                                        elevation: "0",
                                                        disabled: !_ctx.valid,
                                                        size: "x-small"
                                                      }, null, 8, ["disabled"])
                                                    ], 16)
                                                  ]),
                                                  default: _withCtx(() => [
                                                    _cache[60] || (_cache[60] = _createElementVNode("span", null, "Client passé en perte", -1))
                                                  ]),
                                                  _: 2
                                                }, 1032, ["disabled"])
                                              ]))
                                            : (_openBlock(), _createElementBlock("td", _hoisted_42, [
                                                _createVNode(_component_v_btn_icon, {
                                                  icon: "$spellcheck",
                                                  elevation: "0",
                                                  onClick: _withModifiers(($event: any) => (_ctx.openProvisionDialog(props.item)), ["stop"]),
                                                  size: "x-small"
                                                }, null, 8, ["onClick"])
                                              ])),
                                        (
                                                props.item.unrecoverableLoss &&
                                                props.item.unrecoverableLoss.documents &&
                                                props.item.unrecoverableLoss.documents.length
                                            )
                                          ? (_openBlock(), _createElementBlock("td", _hoisted_43, [
                                              _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                    -props.item.unrecoverableLoss
                                                        .cumulated4SignedAmount,
                                                    undefined,
                                                )) + " ", 1),
                                              _createVNode(_component_v_btn_icon, {
                                                icon: "$remove_red_eye",
                                                onClick: ($event: any) => (
                                                    _ctx.openUnrecoverableLossList(
                                                        props.item.unrecoverableLoss.documents,
                                                        props.item.customer,
                                                    )
                                                ),
                                                size: "x-small"
                                              }, null, 8, ["onClick"])
                                            ]))
                                          : (_openBlock(), _createElementBlock("td", _hoisted_44, "-")),
                                        (
                                                _ctx.accountingPeriod.closed ||
                                                props.item.validated ||
                                                props.item.ignored
                                            )
                                          ? (_openBlock(), _createElementBlock("td", _hoisted_45, [
                                              _createVNode(_component_v_btn_icon, {
                                                icon: "$spellcheck",
                                                disabled: "",
                                                size: "x-small"
                                              })
                                            ]))
                                          : (!_ctx.fullUnrecoverableCustomer(props.item))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_46, [
                                                _createVNode(_component_v_btn_icon, {
                                                  icon: "$spellcheck",
                                                  elevation: "0",
                                                  onClick: _withModifiers(($event: any) => (
                                                    _ctx.openUnrecoverableLossDialog(props.item)
                                                ), ["stop"]),
                                                  size: "x-small"
                                                }, null, 8, ["onClick"])
                                              ]))
                                            : (_openBlock(), _createElementBlock("td", _hoisted_47, [
                                                _createVNode(_component_v_tooltip, {
                                                  disabled: _ctx.valid2,
                                                  location: "bottom"
                                                }, {
                                                  activator: _withCtx(({ props }) => [
                                                    _createElementVNode("div", _mergeProps(props, { class: "d-inline-block" }), [
                                                      _createVNode(_component_v_btn, {
                                                        disabled: !_ctx.valid2,
                                                        size: "x-small",
                                                        icon: "$spellcheck"
                                                      }, null, 8, ["disabled"])
                                                    ], 16)
                                                  ]),
                                                  default: _withCtx(() => [
                                                    _cache[61] || (_cache[61] = _createElementVNode("span", null, "Client passé en perte", -1))
                                                  ]),
                                                  _: 2
                                                }, 1032, ["disabled"])
                                              ])),
                                        _createElementVNode("td", _hoisted_48, [
                                          (_ctx.accountingPeriod && _ctx.accountingPeriod.closed)
                                            ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                                key: 0,
                                                icon: "\n                                                    $add_circle_outline\n                                                ",
                                                disabled: "",
                                                size: "x-small"
                                              }))
                                            : (_openBlock(), _createBlock(_component_v_btn_icon, {
                                                key: 1,
                                                icon: "\n                                                    $create\n\n                                                    $add_circle_outline\n                                                ",
                                                onClick: ($event: any) => (_ctx.expandComment(props.item)),
                                                size: "x-small"
                                              }, null, 8, ["onClick"]))
                                        ]),
                                        _createElementVNode("td", null, [
                                          (_ctx.accountingPeriod.closed)
                                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                                key: 0,
                                                rounded: "",
                                                elevation: "0",
                                                disabled: "",
                                                size: "x-small"
                                              }, {
                                                default: _withCtx(() => _cache[62] || (_cache[62] = [
                                                  _createTextVNode(" - ")
                                                ])),
                                                _: 1
                                              }))
                                            : (
                                                    !props.item.validated && props.item.ignored
                                                )
                                              ? (_openBlock(), _createBlock(_component_v_btn, {
                                                  key: 1,
                                                  rounded: "",
                                                  elevation: "0",
                                                  disabled: "",
                                                  size: "x-small"
                                                }, {
                                                  default: _withCtx(() => _cache[63] || (_cache[63] = [
                                                    _createTextVNode(" Valider ")
                                                  ])),
                                                  _: 1
                                                }))
                                              : (!props.item.validated)
                                                ? (_openBlock(), _createBlock(_component_v_btn, {
                                                    key: 2,
                                                    rounded: "",
                                                    elevation: "0",
                                                    onClick: ($event: any) => (_ctx.validateCustomer(props.item)),
                                                    size: "x-small"
                                                  }, {
                                                    default: _withCtx(() => _cache[64] || (_cache[64] = [
                                                      _createTextVNode(" Valider ")
                                                    ])),
                                                    _: 2
                                                  }, 1032, ["onClick"]))
                                                : (_openBlock(), _createBlock(_component_v_btn, {
                                                    key: 3,
                                                    rounded: "",
                                                    elevation: "0",
                                                    onClick: ($event: any) => (_ctx.validateCustomer(props.item)),
                                                    size: "x-small"
                                                  }, {
                                                    default: _withCtx(() => _cache[65] || (_cache[65] = [
                                                      _createTextVNode(" Invalider ")
                                                    ])),
                                                    _: 2
                                                  }, 1032, ["onClick"]))
                                        ]),
                                        _createElementVNode("td", null, [
                                          (_ctx.disabledIgnoreBtn(props.item))
                                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                                key: 0,
                                                rounded: "",
                                                elevation: "0",
                                                disabled: "",
                                                size: "x-small"
                                              }, {
                                                default: _withCtx(() => _cache[66] || (_cache[66] = [
                                                  _createTextVNode(" Ignorer ")
                                                ])),
                                                _: 1
                                              }))
                                            : (!props.item.ignored)
                                              ? (_openBlock(), _createBlock(_component_v_btn, {
                                                  key: 1,
                                                  rounded: "",
                                                  elevation: "0",
                                                  onClick: ($event: any) => (_ctx.ignoreCustomer(props.item)),
                                                  size: "x-small"
                                                }, {
                                                  default: _withCtx(() => _cache[67] || (_cache[67] = [
                                                    _createTextVNode(" Ignorer ")
                                                  ])),
                                                  _: 2
                                                }, 1032, ["onClick"]))
                                              : (_openBlock(), _createBlock(_component_v_btn, {
                                                  key: 2,
                                                  rounded: "",
                                                  elevation: "0",
                                                  onClick: ($event: any) => (_ctx.ignoreCustomer(props.item)),
                                                  size: "x-small"
                                                }, {
                                                  default: _withCtx(() => _cache[68] || (_cache[68] = [
                                                    _createTextVNode(" Ne pas ignorer ")
                                                  ])),
                                                  _: 2
                                                }, 1032, ["onClick"]))
                                        ]),
                                        _createElementVNode("td", _hoisted_49, [
                                          _createVNode(_component_v_menu, { "offset-y": "" }, {
                                            activator: _withCtx(({ props }) => [
                                              _createVNode(_component_v_btn_icon, _mergeProps({ icon: "$dots_vertical" }, props, {
                                                size: "x-small",
                                                class: "mx-1",
                                                color: "secondary"
                                              }), null, 16)
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list, null, {
                                                default: _withCtx(() => [
                                                  (_ctx.accountingPeriod.closed)
                                                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                        key: 0,
                                                        disabled: ""
                                                      }, {
                                                        append: _withCtx(() => [
                                                          _createVNode(_component_v_icon, null, {
                                                            default: _withCtx(() => _cache[70] || (_cache[70] = [
                                                              _createTextVNode("$spellcheck")
                                                            ])),
                                                            _: 1
                                                          })
                                                        ]),
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_list_item_title, null, {
                                                            default: _withCtx(() => _cache[69] || (_cache[69] = [
                                                              _createTextVNode(" Supprimer provisions, pertes et commentaires de l'exercice ")
                                                            ])),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _: 1
                                                      }))
                                                    : (
                                                            props.item.globals &&
                                                            props.item.globals.ACRs &&
                                                            props.item.globals.ACRs[0] &&
                                                            props.item.globals.ACRs[0].acrId
                                                        )
                                                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                          key: 1,
                                                          onClick: ($event: any) => (
                                                            _ctx.deleteAuditCheckResult(
                                                                props.item.globals.ACRs,
                                                            )
                                                        )
                                                        }, {
                                                          append: _withCtx(() => [
                                                            _createVNode(_component_v_icon, { size: "small" }, {
                                                              default: _withCtx(() => _cache[72] || (_cache[72] = [
                                                                _createTextVNode(" $oss-trash ")
                                                              ])),
                                                              _: 1
                                                            })
                                                          ]),
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_list_item_title, null, {
                                                              default: _withCtx(() => _cache[71] || (_cache[71] = [
                                                                _createTextVNode(" Supprimer provisions, pertes et commentaires de l'exercice ")
                                                              ])),
                                                              _: 1
                                                            })
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["onClick"]))
                                                      : _createCommentVNode("", true)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                "expanded-row": _withCtx(({ columns, item }) => [
                                  _createElementVNode("td", {
                                    colspan: columns.length,
                                    style: {"height":"120px","padding-top":"0","margin-top":"0"}
                                  }, [
                                    _createVNode(_component_v_textarea, {
                                      outlined: "",
                                      dense: "",
                                      modelValue: item.comment,
                                      "onUpdate:modelValue": [($event: any) => ((item.comment) = $event), ($event: any) => (_ctx.addComment(item))],
                                      disabled: _ctx.closedPeriod || _ctx.validated,
                                      style: {"margin-right":"auto","margin-left":"auto","padding":"10px","border":"1px #ededed solid"},
                                      label: "Commentaire"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                                  ], 8, _hoisted_50)
                                ]),
                                _: 1
                              }, 8, ["headers", "items", "expanded", "loading"])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })),
                (_ctx.existingCreditNotes.length > 0)
                  ? _withDirectives((_openBlock(), _createBlock(_component_v_card, {
                      key: 3,
                      elevation: "0",
                      class: "px-4 my-4",
                      style: {"border-radius":"25px"}
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_51, [
                          _createVNode(_component_v_expand_transition, null, {
                            default: _withCtx(() => [
                              (_ctx.existingCreditNotes.length > 0)
                                ? _withDirectives((_openBlock(), _createBlock(_component_v_card_text, {
                                    key: 0,
                                    class: "pa-0"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_row, { class: "px-5 pt-3" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, null, {
                                            default: _withCtx(() => [
                                              _createElementVNode("h3", null, _toDisplayString(_ctx.creditNotesCustomer.name) + " - Avoirs à établir", 1)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_card_text, { class: "py-4" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_data_table, {
                                            headers: _ctx.creditNotesListHeaders,
                                            items: _ctx.existingCreditNotes,
                                            "sort-by": [
                                            { key: 'date' },
                                            { key: 'name' },
                                            { key: 'netAmountSigned' },
                                            { key: 'grossAmountSigned' },
                                        ],
                                            loading: _ctx.loading,
                                            class: "table",
                                            style: {"border":"1px #ededed solid"}
                                          }, {
                                            "no-data": _withCtx(() => _cache[73] || (_cache[73] = [
                                              _createTextVNode("Aucun passage en perte irrécouvrable précédente")
                                            ])),
                                            item: _withCtx((props) => [
                                              _createElementVNode("tr", null, [
                                                (props.item.date)
                                                  ? (_openBlock(), _createElementBlock("td", _hoisted_52, _toDisplayString(_ctx.formatDate(props.item.date)), 1))
                                                  : (_openBlock(), _createElementBlock("td", _hoisted_53, "-")),
                                                (props.item.name)
                                                  ? (_openBlock(), _createElementBlock("td", _hoisted_54, _toDisplayString(props.item.name), 1))
                                                  : (_openBlock(), _createElementBlock("td", _hoisted_55)),
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.item
                                                        .accountingLines, (al, index) => {
                                                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                                    (
                                                            al.accountableAccount &&
                                                            al.accountableAccount.name &&
                                                            al.accountableAccount.name.startsWith(
                                                                '7',
                                                            ) &&
                                                            al.amountSigned
                                                        )
                                                      ? (_openBlock(), _createElementBlock("td", {
                                                          key: index,
                                                          class: "text-right"
                                                        }, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                al.amountSigned,
                                                                { currency: "", DC: true },
                                                            )), 1))
                                                      : _createCommentVNode("", true),
                                                    (
                                                            al.accountableAccount &&
                                                            al.accountableAccount.name &&
                                                            al.accountableAccount.name.startsWith(
                                                                '445',
                                                            ) &&
                                                            al.amountSigned &&
                                                            !al.accountableAccount.name.startsWith(
                                                                '7',
                                                            ) &&
                                                            !al.accountableAccount.name.startsWith(
                                                                '41',
                                                            )
                                                        )
                                                      ? (_openBlock(), _createElementBlock("td", {
                                                          key: index,
                                                          class: "text-right"
                                                        }, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                al.amountSigned,
                                                                { currency: "", DC: true },
                                                            )), 1))
                                                      : (
                                                            props.item.accountingLines.length ===
                                                                2 &&
                                                            !al.accountableAccount.name.startsWith(
                                                                '41',
                                                            )
                                                        )
                                                        ? (_openBlock(), _createElementBlock("td", _hoisted_56, " - "))
                                                        : _createCommentVNode("", true),
                                                    (
                                                            al.accountableAccount &&
                                                            al.accountableAccount.name &&
                                                            al.accountableAccount.name.startsWith(
                                                                '41',
                                                            ) &&
                                                            al.amountSigned
                                                        )
                                                      ? (_openBlock(), _createElementBlock("td", {
                                                          key: index,
                                                          class: "text-right"
                                                        }, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                al.amountSigned,
                                                                { currency: "", DC: true },
                                                            )), 1))
                                                      : _createCommentVNode("", true)
                                                  ], 64))
                                                }), 128)),
                                                _createElementVNode("td", _hoisted_57, [
                                                  _createVNode(_component_v_btn_icon, {
                                                    icon: "$remove_red_eye",
                                                    onClick: ($event: any) => (_ctx.openDocument(props.item))
                                                  }, null, 8, ["onClick"])
                                                ])
                                              ])
                                            ]),
                                            _: 1
                                          }, 8, ["headers", "items", "loading"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 512)), [
                                    [_vShow, _ctx.expand4]
                                  ])
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }, 512)), [
                      [_vShow, _ctx.expand4]
                    ])
                  : _createCommentVNode("", true),
                (_ctx.provisionsDialog)
                  ? (_openBlock(), _createBlock(_component_v_dialog, {
                      key: 4,
                      modelValue: _ctx.provisionsDialog,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.provisionsDialog) = $event)),
                      width: "90%",
                      class: "justify-space-around"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, null, {
                          default: _withCtx(() => [
                            (_ctx.selectedCustomer && _ctx.selectedCustomer.name)
                              ? (_openBlock(), _createBlock(_component_v_card_title, { key: 0 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Passer une provision pour le client " + _toDisplayString(_ctx.selectedCustomer.name), 1)
                                  ]),
                                  _: 1
                                }))
                              : (_openBlock(), _createBlock(_component_v_card_title, { key: 1 }, {
                                  default: _withCtx(() => _cache[74] || (_cache[74] = [
                                    _createTextVNode("Pas de client sélectionné")
                                  ])),
                                  _: 1
                                })),
                            _createVNode(_component_v_window, {
                              modelValue: _ctx.step,
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.step) = $event))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_window_item, { value: 1 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_divider),
                                    _createVNode(_component_v_card_text, { class: "px-4 py-0" }, {
                                      default: _withCtx(() => [
                                        (_ctx.provision6Base)
                                          ? (_openBlock(), _createBlock(_component_v_row, {
                                              key: 0,
                                              "no-gutters": "",
                                              class: "px-2 py-4"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_col, { "align-center": "" }, {
                                                  default: _withCtx(() => _cache[75] || (_cache[75] = [
                                                    _createElementVNode("h3", null, " Créance totale (base de calcul du pourcentage) : ", -1)
                                                  ])),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_col, {
                                                  cols: "3",
                                                  class: "d-flex justify-end align-center"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                    _ctx.provisionBaseGrossAmountSigned,
                                                    undefined,
                                                )) + " TTC ", 1)
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_col, {
                                                  cols: "3",
                                                  class: "d-flex justify-end align-center"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(-_ctx.provision6Base, undefined)) + " HT ", 1)
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_divider),
                                    _createVNode(_component_v_card_text, { class: "px-4 py-0" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_row, {
                                          "no-gutters": "",
                                          class: "px-2 py-4"
                                        }, {
                                          default: _withCtx(() => [
                                            (_ctx.cumulated4Provisions)
                                              ? (_openBlock(), _createBlock(_component_v_col, {
                                                  key: 0,
                                                  cols: "3",
                                                  class: "d-flex align-center"
                                                }, {
                                                  default: _withCtx(() => _cache[76] || (_cache[76] = [
                                                    _createElementVNode("h3", null, "Provisions précédentes :", -1)
                                                  ])),
                                                  _: 1
                                                }))
                                              : (_openBlock(), _createBlock(_component_v_col, {
                                                  key: 1,
                                                  cols: "3",
                                                  class: "d-flex align-center"
                                                }, {
                                                  default: _withCtx(() => _cache[77] || (_cache[77] = [
                                                    _createElementVNode("h3", null, "Pas de provisions précédentes", -1)
                                                  ])),
                                                  _: 1
                                                })),
                                            (_ctx.cumulatedPercent)
                                              ? (_openBlock(), _createBlock(_component_v_col, {
                                                  key: 2,
                                                  cols: "1",
                                                  class: "d-flex align-center text-right"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.cumulatedPercent.toFixed(2)) + "% ", 1)
                                                  ]),
                                                  _: 1
                                                }))
                                              : (_openBlock(), _createBlock(_component_v_col, {
                                                  key: 3,
                                                  cols: "1",
                                                  class: "d-flex align-center text-right"
                                                })),
                                            (_ctx.cumulated4Provisions)
                                              ? (_openBlock(), _createBlock(_component_v_col, {
                                                  key: 4,
                                                  cols: "2",
                                                  class: "d-flex align-center text-center"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                    -_ctx.cumulated4Provisions,
                                                    undefined,
                                                )) + " HT ", 1)
                                                  ]),
                                                  _: 1
                                                }))
                                              : (_openBlock(), _createBlock(_component_v_col, {
                                                  key: 5,
                                                  cols: "2",
                                                  class: "d-flex align-center text-center"
                                                })),
                                            _createVNode(_component_v_col, {
                                              cols: "2",
                                              class: "d-flex align-center"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_oss_text_field, {
                                                  modelValue: _ctx.newPercent,
                                                  "onUpdate:modelValue": [
                                                    _cache[15] || (_cache[15] = ($event: any) => ((_ctx.newPercent) = $event)),
                                                    _cache[16] || (_cache[16] = ($event: any) => (_ctx.generateProvisionsDocuments()))
                                                  ],
                                                  suffix: '',
                                                  required: "",
                                                  "error-messages": _ctx.errorMessage,
                                                  label: "Nouveau % global",
                                                  rules: [
                                                    (v) => v >= 0 || 'Min 0',
                                                    (v) => v <= 100 || 'Max 100%',
                                                ],
                                                  hideDetails: false
                                                }, null, 8, ["modelValue", "error-messages", "rules"])
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_spacer),
                                            (_ctx.new4ProvisionAmount && _ctx.new4ProvisionAmount != 0)
                                              ? (_openBlock(), _createBlock(_component_v_col, {
                                                  key: 6,
                                                  cols: "2",
                                                  class: "d-flex justify-end align-center"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                    -_ctx.new4ProvisionAmount,
                                                    undefined,
                                                )) + " HT ", 1)
                                                  ]),
                                                  _: 1
                                                }))
                                              : (_openBlock(), _createBlock(_component_v_col, {
                                                  key: 7,
                                                  cols: "2",
                                                  class: "d-flex justify-end align-center"
                                                }))
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_divider),
                                    _createVNode(_component_v_card_text, { class: "px-4 py-0" }, {
                                      default: _withCtx(() => [
                                        (_ctx.newPercent || (!_ctx.newPercent && _ctx.cumulatedPercent))
                                          ? (_openBlock(), _createBlock(_component_v_row, {
                                              key: 0,
                                              "no-gutters": "",
                                              class: "py-4 px-2"
                                            }, {
                                              default: _withCtx(() => [
                                                (_ctx.delta4ProvisionAmount && _ctx.cumulated4Provisions)
                                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                                      key: 0,
                                                      cols: "3",
                                                      class: "d-flex align-center"
                                                    }, {
                                                      default: _withCtx(() => _cache[78] || (_cache[78] = [
                                                        _createElementVNode("h3", null, "Variation :", -1)
                                                      ])),
                                                      _: 1
                                                    }))
                                                  : (_openBlock(), _createBlock(_component_v_col, {
                                                      key: 1,
                                                      cols: "3",
                                                      class: "d-flex align-center"
                                                    })),
                                                (_ctx.deltaPercent && _ctx.cumulated4Provisions)
                                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                                      key: 2,
                                                      cols: "1",
                                                      class: "d-flex align-center text-right"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.deltaPercent.toFixed(2)) + "% ", 1)
                                                      ]),
                                                      _: 1
                                                    }))
                                                  : (_openBlock(), _createBlock(_component_v_col, {
                                                      key: 3,
                                                      cols: "1",
                                                      class: "d-flex align-center"
                                                    })),
                                                _createVNode(_component_v_col, { cols: "2" }),
                                                (
                                                _ctx.delta4ProvisionAmount < 0 &&
                                                this.cumulated4Provisions
                                            )
                                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                                      key: 4,
                                                      cols: "4",
                                                      class: "d-flex align-center"
                                                    }, {
                                                      default: _withCtx(() => _cache[79] || (_cache[79] = [
                                                        _createElementVNode("h3", null, "Augmentation (Dotation) :", -1)
                                                      ])),
                                                      _: 1
                                                    }))
                                                  : (
                                                _ctx.delta4ProvisionAmount > 0 &&
                                                this.cumulated4Provisions
                                            )
                                                    ? (_openBlock(), _createBlock(_component_v_col, {
                                                        key: 5,
                                                        cols: "4",
                                                        class: "d-flex align-center"
                                                      }, {
                                                        default: _withCtx(() => _cache[80] || (_cache[80] = [
                                                          _createElementVNode("h3", null, "Diminution (Reprise) :", -1)
                                                        ])),
                                                        _: 1
                                                      }))
                                                    : (_openBlock(), _createBlock(_component_v_col, {
                                                        key: 6,
                                                        cols: "4",
                                                        class: "d-flex align-center"
                                                      }, {
                                                        default: _withCtx(() => _cache[81] || (_cache[81] = [
                                                          _createElementVNode("h3", null, "Dotation aux provisions :", -1)
                                                        ])),
                                                        _: 1
                                                      })),
                                                (_ctx.delta4ProvisionAmount)
                                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                                      key: 7,
                                                      cols: "2",
                                                      class: "d-flex justify-end align-center"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                    -_ctx.delta4ProvisionAmount,
                                                    undefined,
                                                )) + " HT ", 1)
                                                      ]),
                                                      _: 1
                                                    }))
                                                  : (_openBlock(), _createBlock(_component_v_col, {
                                                      key: 8,
                                                      cols: "2",
                                                      class: "d-flex align-center"
                                                    }))
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_divider),
                                    (_ctx.provisionDocumentsAls && _ctx.provisionDocumentsAls.length)
                                      ? (_openBlock(), _createBlock(_component_GetEmptyDocumentsTable, {
                                          key: 0,
                                          documentAlsCreate: _ctx.provisionDocumentsAls,
                                          accountableAccounts: _ctx.storeAccountableAccounts
                                        }, null, 8, ["documentAlsCreate", "accountableAccounts"]))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_v_divider),
                                    _createVNode(_component_v_card_actions, { style: {"padding-right":"24px","padding-left":"24px"} }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_btn, {
                                          rounded: "",
                                          class: "ma-2",
                                          onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.previous(1))),
                                          color: 'primary',
                                          size: "x-small"
                                        }, {
                                          default: _withCtx(() => _cache[82] || (_cache[82] = [
                                            _createTextVNode(" Précédent ")
                                          ])),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_spacer),
                                        _createVNode(_component_v_btn, {
                                          rounded: "",
                                          class: "ma-2",
                                          color: 'primary',
                                          onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.validateProvision())),
                                          size: "x-small"
                                        }, {
                                          default: _withCtx(() => _cache[83] || (_cache[83] = [
                                            _createTextVNode(" Valider ")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"]))
                  : _createCommentVNode("", true),
                (_ctx.unrecoverableLossDialog)
                  ? (_openBlock(), _createBlock(_component_v_dialog, {
                      key: 5,
                      modelValue: _ctx.unrecoverableLossDialog,
                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.unrecoverableLossDialog) = $event)),
                      width: "90%",
                      class: "justify-space-around"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, null, {
                          default: _withCtx(() => [
                            (_ctx.selectedCustomer && _ctx.selectedCustomer.name)
                              ? (_openBlock(), _createBlock(_component_v_card_title, { key: 0 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.selectedCustomer.name) + " - Passer la créance en perte irrécouvrable ", 1)
                                  ]),
                                  _: 1
                                }))
                              : (_openBlock(), _createBlock(_component_v_card_title, { key: 1 }, {
                                  default: _withCtx(() => _cache[84] || (_cache[84] = [
                                    _createTextVNode("Pas de client sélectionné")
                                  ])),
                                  _: 1
                                })),
                            _createVNode(_component_v_window, {
                              modelValue: _ctx.stepUL,
                              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.stepUL) = $event))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_window_item, { value: 1 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card_subtitle, null, {
                                      default: _withCtx(() => [
                                        (_ctx.provisionReversal)
                                          ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_col, null, {
                                                  default: _withCtx(() => _cache[85] || (_cache[85] = [
                                                    _createElementVNode("h3", null, "Reprise des provisions précédentes :", -1)
                                                  ])),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_col, null, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                    -_ctx.provisionReversal,
                                                    undefined,
                                                )) + " HT ", 1)
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_spacer),
                                                _createVNode(_component_v_col, { style: {"text-align":"right"} }, {
                                                  default: _withCtx(() => _cache[86] || (_cache[86] = [
                                                    _createTextVNode("c/491000 à c/781740 ")
                                                  ])),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }))
                                          : (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_col, null, {
                                                  default: _withCtx(() => _cache[87] || (_cache[87] = [
                                                    _createTextVNode("Pas de provisions précédentes")
                                                  ])),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }))
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_card_text, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_row, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, { cols: "auto" }, {
                                              default: _withCtx(() => _cache[88] || (_cache[88] = [
                                                _createElementVNode("h3", null, " Détail des écritures non lettrées à passer en perte irrécouvrable : ", -1)
                                              ])),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_spacer),
                                            _createVNode(_component_v_col, { style: {"text-align":"right"} }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" c/654000 + c4457xx à 411000 " + _toDisplayString(_ctx.selectedCustomer.name), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_switch, {
                                          modelValue: _ctx.switchManual,
                                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.switchManual) = $event)),
                                          label: `Modifier les bases HT`,
                                          style: {},
                                          class: "ml-2"
                                        }, null, 8, ["modelValue"]),
                                        (
                                            _ctx.vatBasis00AmountSigned && !_ctx.manualExportNetAmountSigned
                                        )
                                          ? (_openBlock(), _createElementBlock("h3", _hoisted_58, " HT comptabilisé dans des ODs, restant à repartir parmi le CA export : " + _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.vatBasis00AmountSigned, {
                                                currency: "",
                                                DC: true,
                                            })), 1))
                                          : (
                                            _ctx.vatBasis00AmountSigned &&
                                            _ctx.manualExportNetAmountSigned &&
                                            (_ctx.vatBasis00AmountSigned - _ctx.manualExportNetAmountSigned <
                                                1 ||
                                                _ctx.vvatBasis00AmountSigned -
                                                    _ctx.manualExportNetAmountSigned >
                                                    -1)
                                        )
                                            ? (_openBlock(), _createElementBlock("h3", _hoisted_59, " HT comptabilisé dans des ODs, restant à repartir parmi le CA export : " + _toDisplayString(_ctx.newCommonFormatCurrency(
                                                _ctx.vatBasis00AmountSigned -
                                                    _ctx.manualExportNetAmountSigned,
                                                { currency: "", DC: true },
                                            )), 1))
                                            : _createCommentVNode("", true),
                                        _createVNode(_component_v_data_table, {
                                          headers: 
                                            _ctx.switchManual
                                                ? _ctx.manualUnrecoverableLossDialogHeaders
                                                : _ctx.unrecoverableLossDialogHeaders
                                        ,
                                          items: Object.values(_ctx.vatBasis),
                                          "sort-by": [{ key: 'sort', order: false }],
                                          "sort-desc": [false, true],
                                          "hide-default-footer": "",
                                          loading: _ctx.loading,
                                          class: "table",
                                          style: {"border":"1px #ededed solid"}
                                        }, {
                                          "no-data": _withCtx(() => _cache[89] || (_cache[89] = [
                                            _createTextVNode("Aucune facture échue")
                                          ])),
                                          item: _withCtx((props) => [
                                            _createElementVNode("tr", null, [
                                              (props.item.sort === 'HT-a-generic')
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_60, _toDisplayString(props.item.text), 1))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_61, _toDisplayString(props.item.text), 1)),
                                              _createElementVNode("td", _hoisted_62, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            -props.item.amountSigned,
                                                            undefined,
                                                        )), 1),
                                              (props.item.sort === 'HT-a-generic')
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_63, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            props.item.previousNetAmountSigned,
                                                            undefined,
                                                        )), 1))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_64, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            props.item.previousNetAmountSigned,
                                                            undefined,
                                                        )), 1)),
                                              (
                                                        _ctx.switchManual && props.item.gapAmountSigned
                                                    )
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_65, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            -props.item.gapAmountSigned,
                                                            undefined,
                                                        )), 1))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_66, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            -props.item.gapAmountSigned,
                                                            undefined,
                                                        )), 1)),
                                              (_ctx.switchManual)
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_67, [
                                                    _createVNode(_component_oss_text_field, {
                                                      modelValue: props.item.manualAmount,
                                                      "onUpdate:modelValue": ($event: any) => ((props.item.manualAmount) = $event),
                                                      outlined: "",
                                                      dense: "",
                                                      required: "",
                                                      suffix: '€',
                                                      hideDetails: false,
                                                      onChange: ($event: any) => (
                                                            _ctx.changeManualUnrecoverableLoss(
                                                                props.item,
                                                            )
                                                        )
                                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (
                                                        _ctx.switchManual &&
                                                        props.item.manualVatAmountSigned
                                                    )
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_68, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            -props.item.manualVatAmountSigned,
                                                            undefined,
                                                        )), 1))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_69, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            -props.item.vatAmountSigned,
                                                            undefined,
                                                        )), 1)),
                                              (
                                                        _ctx.switchManual &&
                                                        props.item.manualGrossAmountSigned
                                                    )
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_70, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            props.item.manualGrossAmountSigned,
                                                            undefined,
                                                        )), 1))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_71, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            props.item.grossAmountSigned,
                                                            undefined,
                                                        )), 1))
                                            ])
                                          ]),
                                          "body.append": _withCtx(() => [
                                            _createElementVNode("tr", _hoisted_72, [
                                              _cache[90] || (_cache[90] = _createElementVNode("th", null, "Totaux", -1)),
                                              _createElementVNode("th", _hoisted_73, [
                                                _createElementVNode("h3", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                -_ctx.sumsUnrecoverableLossDialogTable(
                                                                    undefined,
                                                                    "amountSigned",
                                                                ),
                                                                undefined,
                                                            )), 1)
                                              ]),
                                              _createElementVNode("th", _hoisted_74, [
                                                _createElementVNode("h3", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                _ctx.sumsUnrecoverableLossDialogTable(
                                                                    undefined,
                                                                    "previousNetAmountSigned",
                                                                ),
                                                                undefined,
                                                            )), 1)
                                              ]),
                                              _createElementVNode("th", _hoisted_75, [
                                                _createElementVNode("h3", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                -_ctx.sumsUnrecoverableLossDialogTable(
                                                                    "gapAmountSigned",
                                                                    undefined,
                                                                ),
                                                                undefined,
                                                            )), 1)
                                              ]),
                                              (_ctx.switchManual)
                                                ? (_openBlock(), _createElementBlock("th", _hoisted_76, [
                                                    _createElementVNode("h3", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                -_ctx.sumsUnrecoverableLossDialogTable(
                                                                    "manualAmountSigned",
                                                                    undefined,
                                                                ),
                                                                undefined,
                                                            )), 1)
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (_ctx.switchManual)
                                                ? (_openBlock(), _createElementBlock("th", _hoisted_77, [
                                                    _createElementVNode("h3", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                -_ctx.sumsUnrecoverableLossDialogTable(
                                                                    "manualVatAmountSigned",
                                                                    "vatAmountSigned",
                                                                ),
                                                                undefined,
                                                            )), 1)
                                                  ]))
                                                : (_openBlock(), _createElementBlock("th", _hoisted_78, [
                                                    _createElementVNode("h3", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                -_ctx.sumsUnrecoverableLossDialogTable(
                                                                    undefined,
                                                                    "vatAmountSigned",
                                                                ),
                                                                undefined,
                                                            )), 1)
                                                  ])),
                                              (_ctx.switchManual)
                                                ? (_openBlock(), _createElementBlock("th", _hoisted_79, [
                                                    _createElementVNode("h3", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                _ctx.sumsUnrecoverableLossDialogTable(
                                                                    "manualGrossAmountSigned",
                                                                    "grossAmountSigned",
                                                                ),
                                                                undefined,
                                                            )), 1)
                                                  ]))
                                                : (_openBlock(), _createElementBlock("th", _hoisted_80, [
                                                    _createElementVNode("h3", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                _ctx.sumsUnrecoverableLossDialogTable(
                                                                    undefined,
                                                                    "grossAmountSigned",
                                                                ),
                                                                undefined,
                                                            )), 1)
                                                  ]))
                                            ])
                                          ]),
                                          _: 1
                                        }, 8, ["headers", "items", "loading"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_divider),
                                    _createVNode(_component_v_card_actions, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_btn, {
                                          rounded: "",
                                          class: "ma-2",
                                          onClick: _ctx.quitUnrecoverableLossDialog,
                                          color: 'primary',
                                          size: "x-small"
                                        }, {
                                          default: _withCtx(() => _cache[91] || (_cache[91] = [
                                            _createTextVNode(" Annuler ")
                                          ])),
                                          _: 1
                                        }, 8, ["onClick"]),
                                        _createVNode(_component_v_spacer),
                                        _createVNode(_component_v_btn, {
                                          rounded: "",
                                          class: "ma-2",
                                          color: 'primary',
                                          onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.generateUnrecoverableLossDocuments())),
                                          size: "x-small"
                                        }, {
                                          default: _withCtx(() => _cache[92] || (_cache[92] = [
                                            _createTextVNode(" Suivant ")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_window_item, { value: 2 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, null, {
                                      default: _withCtx(() => _cache[93] || (_cache[93] = [
                                        _createElementVNode("h2", { class: "pl-4" }, "Récapitulatif, avant validation", -1)
                                      ])),
                                      _: 1
                                    }),
                                    (_ctx.provisionDocumentsAls && _ctx.provisionDocumentsAls.length)
                                      ? (_openBlock(), _createBlock(_component_GetEmptyDocumentsTable, {
                                          key: 0,
                                          documentAlsCreate: _ctx.provisionDocumentsAls,
                                          accountableAccounts: _ctx.storeAccountableAccounts
                                        }, null, 8, ["documentAlsCreate", "accountableAccounts"]))
                                      : _createCommentVNode("", true),
                                    (
                                        _ctx.unrecoverableLossDocumentsAls &&
                                        _ctx.unrecoverableLossDocumentsAls.length
                                    )
                                      ? (_openBlock(), _createBlock(_component_GetEmptyDocumentsTable, {
                                          key: 1,
                                          documentAlsCreate: _ctx.unrecoverableLossDocumentsAls,
                                          accountableAccounts: _ctx.storeAccountableAccounts
                                        }, null, 8, ["documentAlsCreate", "accountableAccounts"]))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_v_divider),
                                    _createVNode(_component_v_card_actions, { style: {"padding-right":"24px","padding-left":"24px"} }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_btn, {
                                          rounded: "",
                                          class: "ma-2",
                                          onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.previousUL(1))),
                                          color: 'primary',
                                          size: "x-small"
                                        }, {
                                          default: _withCtx(() => _cache[94] || (_cache[94] = [
                                            _createTextVNode(" Précédent ")
                                          ])),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_spacer),
                                        (!_ctx.vatBasis00AmountSigned)
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 0,
                                              rounded: "",
                                              class: "ma-2",
                                              color: 'primary',
                                              onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.validateUnrecoverableLoss())),
                                              size: "x-small"
                                            }, {
                                              default: _withCtx(() => _cache[95] || (_cache[95] = [
                                                _createTextVNode(" Valider ")
                                              ])),
                                              _: 1
                                            }))
                                          : (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 1,
                                              rounded: "",
                                              class: "ma-2",
                                              color: 'primary',
                                              disabled: "",
                                              size: "x-small"
                                            }, {
                                              default: _withCtx(() => _cache[96] || (_cache[96] = [
                                                _createTextVNode(" Valider ")
                                              ])),
                                              _: 1
                                            }))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_expand_transition, null, {
                  default: _withCtx(() => [
                    (_ctx.periodDocuments.length > 0)
                      ? _withDirectives((_openBlock(), _createBlock(_component_v_card, {
                          key: 0,
                          elevation: "0",
                          class: "px-4 my-4",
                          style: {"background-color":"white","border-radius":"25px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_text, { class: "px-0" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_81, [
                                  _createVNode(_component_v_card_title, {
                                    class: _normalizeClass(
                                        !_ctx.$vuetify.display.mobile
                                            ? 'title font-weight-regular justify-space-between'
                                            : 'title font-weight-regular pa-1'
                                    )
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("h3", null, _toDisplayString(_ctx.periodsCustomer.name) + " - Factures échues depuis " + _toDisplayString(_ctx.selectedPeriod), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["class"]),
                                  _createVNode(_component_v_data_table, {
                                    headers: _ctx.periodDocumentsHeaders,
                                    items: _ctx.periodDocuments,
                                    "sort-by": [
                                        { key: 'date' },
                                        { key: 'netAmountSigned' },
                                        { key: 'grossAmountSigned' },
                                        { key: 'dueDate' },
                                        { key: 'name' },
                                    ],
                                    loading: _ctx.loading,
                                    class: "table",
                                    style: {"border":"1px #ededed solid"}
                                  }, {
                                    "no-data": _withCtx(() => _cache[97] || (_cache[97] = [
                                      _createTextVNode("Aucune facture échue sur la période")
                                    ])),
                                    item: _withCtx((props) => [
                                      _createElementVNode("tr", null, [
                                        (props.item.date)
                                          ? (_openBlock(), _createElementBlock("td", _hoisted_82, _toDisplayString(_ctx.formatDate(props.item.date)), 1))
                                          : (_openBlock(), _createElementBlock("td", _hoisted_83, "-")),
                                        (props.item.text)
                                          ? (_openBlock(), _createElementBlock("td", _hoisted_84, _toDisplayString(props.item.text), 1))
                                          : (_openBlock(), _createElementBlock("td", _hoisted_85, "-")),
                                        (props.item.invoiceNumber)
                                          ? (_openBlock(), _createElementBlock("td", _hoisted_86, _toDisplayString(props.item.invoiceNumber), 1))
                                          : (_openBlock(), _createElementBlock("td", _hoisted_87, "-")),
                                        (props.item.doc7and6)
                                          ? (_openBlock(), _createElementBlock("td", _hoisted_88, _toDisplayString(_ctx.newCommonFormatCurrency(props.item.doc7and6, {
                                                        currency: "",
                                                        DC: true,
                                                    })), 1))
                                          : (_openBlock(), _createElementBlock("td", _hoisted_89, "-")),
                                        (props.item.doc445)
                                          ? (_openBlock(), _createElementBlock("td", _hoisted_90, _toDisplayString(_ctx.newCommonFormatCurrency(props.item.doc445, {
                                                        currency: "",
                                                        DC: true,
                                                    })), 1))
                                          : (_openBlock(), _createElementBlock("td", _hoisted_91, "-")),
                                        (props.item.doc411)
                                          ? (_openBlock(), _createElementBlock("td", _hoisted_92, _toDisplayString(_ctx.newCommonFormatCurrency(props.item.doc411, {
                                                        currency: "",
                                                        DC: true,
                                                    })), 1))
                                          : (_openBlock(), _createElementBlock("td", _hoisted_93, "-")),
                                        (props.item.dueDate)
                                          ? (_openBlock(), _createElementBlock("td", _hoisted_94, _toDisplayString(_ctx.formatDate(props.item.dueDate)), 1))
                                          : (_openBlock(), _createElementBlock("td", _hoisted_95, "-")),
                                        _createElementVNode("td", _hoisted_96, [
                                          _createVNode(_component_v_btn_icon, {
                                            icon: "$remove_red_eye",
                                            onClick: ($event: any) => (_ctx.openDocument(props.item)),
                                            size: "x-small"
                                          }, null, 8, ["onClick"])
                                        ])
                                      ])
                                    ]),
                                    _: 1
                                  }, 8, ["headers", "items", "loading"])
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 512)), [
                          [_vShow, _ctx.expand]
                        ])
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_expand_transition, null, {
                  default: _withCtx(() => [
                    (_ctx.provisionsList.length > 0)
                      ? _withDirectives((_openBlock(), _createBlock(_component_v_card, {
                          key: 0,
                          elevation: "0",
                          class: "px-4 my-4",
                          style: {"background-color":"white","border-radius":"25px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_text, { class: "px-0" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_97, [
                                  _createVNode(_component_v_card_title, {
                                    class: _normalizeClass(
                                        !_ctx.$vuetify.display.mobile
                                            ? 'title font-weight-regular justify-space-between'
                                            : 'title font-weight-regular pa-1'
                                    )
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("h2", null, _toDisplayString(_ctx.provisionCustomer.name) + " - Provisions et reprises", 1)
                                    ]),
                                    _: 1
                                  }, 8, ["class"]),
                                  _createVNode(_component_v_card_text, { class: "py-0" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_data_table, {
                                        headers: _ctx.provisionsListHeaders,
                                        items: _ctx.provisionsList,
                                        "sort-by": [
                                            { key: 'date' },
                                            { key: 'name' },
                                            { key: 'netAmountSigned' },
                                        ],
                                        loading: _ctx.loading,
                                        class: "table",
                                        style: {"border":"1px #ededed solid"}
                                      }, {
                                        "no-data": _withCtx(() => _cache[98] || (_cache[98] = [
                                          _createTextVNode("Aucune provision ou reprise précédente")
                                        ])),
                                        item: _withCtx((props) => [
                                          _createElementVNode("tr", null, [
                                            (props.item.date)
                                              ? (_openBlock(), _createElementBlock("td", _hoisted_98, _toDisplayString(_ctx.formatDate(props.item.date)), 1))
                                              : (_openBlock(), _createElementBlock("td", _hoisted_99, "-")),
                                            (props.item.name)
                                              ? (_openBlock(), _createElementBlock("td", _hoisted_100, _toDisplayString(props.item.name), 1))
                                              : (
                                                        props.item.accountingLines[0].wording
                                                    )
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_101, _toDisplayString(props.item.accountingLines[0].wording), 1))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_102)),
                                            (
                                                        props.item.data &&
                                                        props.item.data.accountingLines &&
                                                        props.item.data.accountingLines[0] &&
                                                        props.item.data.accountingLines[0]
                                                            .amountSigned
                                                    )
                                              ? (_openBlock(), _createElementBlock("td", _hoisted_103, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            props.item.data.accountingLines[0]
                                                                .amountSigned,
                                                            undefined,
                                                        )), 1))
                                              : (
                                                        props.item.accountingLines &&
                                                        props.item.accountingLines[0] &&
                                                        props.item.accountingLines[0].amountSigned
                                                    )
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_104, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            props.item.accountingLines[0]
                                                                .amountSigned,
                                                            undefined,
                                                        )), 1))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_105, _toDisplayString(_ctx.newCommonFormatCurrency(0, undefined)), 1)),
                                            _createElementVNode("td", _hoisted_106, [
                                              _createVNode(_component_v_btn_icon, {
                                                icon: "$remove_red_eye",
                                                onClick: ($event: any) => (_ctx.openDocument(props.item)),
                                                size: "x-small"
                                              }, null, 8, ["onClick"])
                                            ])
                                          ])
                                        ]),
                                        "body.append": _withCtx(() => [
                                          _createElementVNode("tr", _hoisted_107, [
                                            _cache[99] || (_cache[99] = _createElementVNode("th", null, null, -1)),
                                            _cache[100] || (_cache[100] = _createElementVNode("th", { style: {"text-align":"right","font-weight":"bold"} }, " SOLDE ", -1)),
                                            _createElementVNode("th", _hoisted_108, [
                                              _createElementVNode("h3", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                _ctx.sumsProvisionsTable(),
                                                                undefined,
                                                            )), 1)
                                            ])
                                          ])
                                        ]),
                                        _: 1
                                      }, 8, ["headers", "items", "loading"])
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 512)), [
                          [_vShow, _ctx.expand2]
                        ])
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_expand_transition, null, {
                  default: _withCtx(() => [
                    (_ctx.unrecoverableLossList.length > 0)
                      ? _withDirectives((_openBlock(), _createBlock(_component_v_card, {
                          key: 0,
                          elevation: "0",
                          class: "px-4 my-4",
                          style: {"background-color":"white","border-radius":"25px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_text, { class: "px-0" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_109, [
                                  _createVNode(_component_v_card_title, {
                                    class: _normalizeClass(
                                        !_ctx.$vuetify.display.mobile
                                            ? 'title font-weight-regular justify-space-between'
                                            : 'title font-weight-regular pa-1'
                                    )
                                  }, {
                                    default: _withCtx(() => _cache[101] || (_cache[101] = [
                                      _createElementVNode("h2", null, "Passages en pertes irrécouvrables précédents", -1)
                                    ])),
                                    _: 1
                                  }, 8, ["class"]),
                                  _createVNode(_component_v_card_text, { class: "py-0" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_data_table, {
                                        headers: _ctx.unrecoverableLossListHeaders,
                                        items: _ctx.unrecoverableLossList,
                                        loading: _ctx.loading,
                                        class: "table",
                                        style: {"border":"1px #ededed solid"}
                                      }, {
                                        "no-data": _withCtx(() => _cache[102] || (_cache[102] = [
                                          _createTextVNode("Aucun passage en perte irrécouvrable précédente")
                                        ])),
                                        item: _withCtx((props) => [
                                          _createElementVNode("tr", null, [
                                            (props.item.date)
                                              ? (_openBlock(), _createElementBlock("td", _hoisted_110, _toDisplayString(_ctx.formatDate(props.item.date)), 1))
                                              : (_openBlock(), _createElementBlock("td", _hoisted_111, "-")),
                                            (props.item.name)
                                              ? (_openBlock(), _createElementBlock("td", _hoisted_112, _toDisplayString(props.item.name), 1))
                                              : (_openBlock(), _createElementBlock("td", _hoisted_113)),
                                            (props.item.unrecoverableLossNetAmount)
                                              ? (_openBlock(), _createElementBlock("td", _hoisted_114, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            props.item.unrecoverableLossNetAmount,
                                                            undefined,
                                                        )), 1))
                                              : (_openBlock(), _createElementBlock("td", _hoisted_115, _toDisplayString(_ctx.newCommonFormatCurrency(0, undefined)), 1)),
                                            (props.item.unrecoverableLossVatAmount)
                                              ? (_openBlock(), _createElementBlock("td", _hoisted_116, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            props.item.unrecoverableLossVatAmount,
                                                            undefined,
                                                        )), 1))
                                              : (_openBlock(), _createElementBlock("td", _hoisted_117, _toDisplayString(_ctx.newCommonFormatCurrency(0, undefined)), 1)),
                                            (props.item.unrecoverableLossGrossAmount)
                                              ? (_openBlock(), _createElementBlock("td", _hoisted_118, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            -props.item
                                                                .unrecoverableLossGrossAmount,
                                                            undefined,
                                                        )), 1))
                                              : (_openBlock(), _createElementBlock("td", _hoisted_119, _toDisplayString(_ctx.newCommonFormatCurrency(0, undefined)), 1)),
                                            _createElementVNode("td", _hoisted_120, [
                                              _createVNode(_component_v_btn_icon, {
                                                icon: "$remove_red_eye",
                                                onClick: ($event: any) => (_ctx.openDocument(props.item)),
                                                size: "x-small"
                                              }, null, 8, ["onClick"])
                                            ])
                                          ])
                                        ]),
                                        _: 1
                                      }, 8, ["headers", "items", "loading"])
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 512)), [
                          [_vShow, _ctx.expand3]
                        ])
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                (_ctx.customers && _ctx.customers.length)
                  ? (_openBlock(), _createBlock(_component_v_card, {
                      key: 6,
                      elevation: "0",
                      style: {"background-color":"white","border-radius":"25px"},
                      class: "pa-6 mt-4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "5",
                              class: "ma-auto"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                                  default: _withCtx(() => _cache[103] || (_cache[103] = [
                                    _createElementVNode("h5", { class: "pl-4" }, "Synthèse", -1)
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_spacer),
                            _createVNode(_component_v_col, {
                              cols: "1",
                              class: "d-flex align-center justify-center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "6",
                                      class: "align-center pa-0"
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "6",
                                      class: "align-center pa-0"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_btn_icon, {
                                          icon: 
                                            _ctx.commentsExpand ? '$fa-chevron-up' : '$fa-chevron-down'
                                        ,
                                          onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.commentsExpand = !_ctx.commentsExpand)),
                                          style: {"width":"40px"},
                                          class: "d-inline px-2",
                                          size: "x-small"
                                        }, null, 8, ["icon"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_expand_transition, { "no-gutters": "" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("div", _hoisted_121, [
                              (!_ctx.comments || !_ctx.comments.length)
                                ? (_openBlock(), _createBlock(_component_v_card_text, {
                                    key: 0,
                                    class: "px-4"
                                  }, {
                                    default: _withCtx(() => _cache[104] || (_cache[104] = [
                                      _createTextVNode(" Aucun commentaire saisi ")
                                    ])),
                                    _: 1
                                  }))
                                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.comments, (comment, index) => {
                                    return (_openBlock(), _createBlock(_component_v_card_text, {
                                      key: index,
                                      class: "px-4"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("h3", _hoisted_122, _toDisplayString(comment.title), 1),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.toArray(comment.text), (commentLine, ic) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: ic,
                                            class: "mb-0 px-0"
                                          }, [
                                            _createElementVNode("p", _hoisted_123, _toDisplayString(commentLine), 1)
                                          ]))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                            ], 512), [
                              [_vShow, _ctx.commentsExpand]
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!_ctx.loading && !_ctx.dataLoading)
                  ? (_openBlock(), _createBlock(_component_AuditConnectedAcrDocuments, {
                      key: 7,
                      connectedDocuments: _ctx.connectedDocuments,
                      companyId: _ctx.companyId,
                      acKey: _ctx.acKey,
                      auditCheckResult: _ctx.auditCheckResult || {},
                      accountingPeriodId: _ctx.accountingPeriodId || undefined,
                      onUnlinkedDocument: _cache[28] || (_cache[28] = ($event: any) => (_ctx.unlinkDocument($event))),
                      onShowLinkedDocument: _cache[29] || (_cache[29] = ($event: any) => (_ctx.showLinkedDocument($event)))
                    }, null, 8, ["connectedDocuments", "companyId", "acKey", "auditCheckResult", "accountingPeriodId"]))
                  : _createCommentVNode("", true),
                (!_ctx.loading && !_ctx.dataLoading)
                  ? (_openBlock(), _createBlock(_component_AuditConnectedAcrResults, {
                      key: 8,
                      results: _ctx.results,
                      companyId: _ctx.companyId
                    }, null, 8, ["results", "companyId"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_card, {
                  elevation: "0",
                  style: {"background-color":"white","border-radius":"25px"},
                  class: "pa-6 mt-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "5",
                          class: "ma-auto"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                              default: _withCtx(() => _cache[105] || (_cache[105] = [
                                _createElementVNode("h5", { class: "pl-4" }, "Commentaires détaillés", -1)
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_col, {
                          cols: "1",
                          class: "d-flex align-center justify-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "align-center pa-0"
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "align-center pa-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn_icon, {
                                      icon: 
                                            _ctx.longCommentExpand
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        ,
                                      onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.longCommentExpand = !_ctx.longCommentExpand)),
                                      style: {"width":"40px"},
                                      class: "d-inline px-2",
                                      size: "x-small"
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_ctx.longCommentExpand)
                      ? (_openBlock(), _createBlock(_component_v_card_text, {
                          key: 0,
                          transition: "longCommentExpand"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_text, { class: "px-4" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_textarea, {
                                  modelValue: _ctx.longComment,
                                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.longComment) = $event)),
                                  disabled: _ctx.closedPeriod || _ctx.validated,
                                  "auto-grow": "",
                                  style: {"border":"1px #ededed solid"},
                                  outlined: ""
                                }, null, 8, ["modelValue", "disabled"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { style: {"padding-bottom":"0"} }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, { style: {"padding-top":"20px","padding-bottom":"0","padding-left":"0"} }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_spacer),
                                        (_ctx.closedPeriod)
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 0,
                                              disabled: "",
                                              rounded: "",
                                              class: "btn btn_blue",
                                              size: "small"
                                            }, {
                                              default: _withCtx(() => _cache[106] || (_cache[106] = [
                                                _createTextVNode(" Enregistrer les commentaires ")
                                              ])),
                                              _: 1
                                            }))
                                          : (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 1,
                                              rounded: "",
                                              class: "btn btn_blue",
                                              onClick: _cache[32] || (_cache[32] = _withModifiers(($event: any) => (_ctx.storeComments()), ["stop"])),
                                              size: "small"
                                            }, {
                                              default: _withCtx(() => _cache[107] || (_cache[107] = [
                                                _createTextVNode(" Enregistrer les commentaires ")
                                              ])),
                                              _: 1
                                            }))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card, {
                  elevation: "0",
                  style: {"background-color":"white","border-radius":"25px"},
                  class: "pa-6 mt-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "5",
                          class: "ma-auto"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                              default: _withCtx(() => _cache[108] || (_cache[108] = [
                                _createElementVNode("h5", { class: "pl-4" }, "Commentaires synthétiques", -1)
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_col, {
                          cols: "1",
                          class: "d-flex align-center justify-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "align-center pa-0"
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "align-center pa-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn_icon, {
                                      icon: 
                                            _ctx.shortCommentExpand
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        ,
                                      onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.shortCommentExpand = !_ctx.shortCommentExpand)),
                                      style: {"width":"40px"},
                                      class: "d-inline px-2",
                                      size: "x-small"
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_ctx.shortCommentExpand)
                      ? (_openBlock(), _createBlock(_component_v_card_text, {
                          key: 0,
                          transition: "shortCommentExpand"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_text, { class: "px-4" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_textarea, {
                                  modelValue: _ctx.shortComment,
                                  "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.shortComment) = $event)),
                                  disabled: _ctx.closedPeriod || _ctx.validated,
                                  "auto-grow": "",
                                  style: {"border":"1px #ededed solid"},
                                  outlined: ""
                                }, null, 8, ["modelValue", "disabled"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { style: {"padding-bottom":"0"} }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, { style: {"padding-top":"20px","padding-bottom":"0","padding-left":"0"} }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_spacer),
                                        (_ctx.closedPeriod)
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 0,
                                              disabled: "",
                                              rounded: "",
                                              class: "btn btn_blue",
                                              size: "small"
                                            }, {
                                              default: _withCtx(() => _cache[109] || (_cache[109] = [
                                                _createTextVNode(" Enregistrer les commentaires ")
                                              ])),
                                              _: 1
                                            }))
                                          : (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 1,
                                              rounded: "",
                                              class: "btn btn_blue",
                                              onClick: _cache[35] || (_cache[35] = _withModifiers(($event: any) => (_ctx.storeComments()), ["stop"])),
                                              size: "small"
                                            }, {
                                              default: _withCtx(() => _cache[110] || (_cache[110] = [
                                                _createTextVNode(" Enregistrer les commentaires ")
                                              ])),
                                              _: 1
                                            }))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _withDirectives(_createVNode(_component_v_card, {
                  elevation: "0",
                  style: {"background-color":"white","border-radius":"25px"},
                  class: "pa-6 mt-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "5",
                          class: "ma-auto"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                              default: _withCtx(() => _cache[111] || (_cache[111] = [
                                _createElementVNode("h5", { class: "pl-4" }, "Balance - Grand livre c/411", -1)
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_col, {
                          cols: "1",
                          class: "d-flex align-center px-0 justify-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "align-center pa-0"
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "align-center pa-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn_icon, {
                                      icon: 
                                            _ctx.generalLedgerExpand411
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        ,
                                      onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.generalLedgerExpand411 = !_ctx.generalLedgerExpand411)),
                                      style: {"width":"40px"},
                                      class: "d-inline px-2",
                                      size: "x-small"
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _withDirectives(_createVNode(_component_v_card_text, { transition: "expand" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.periods, (period, x) => {
                          return (_openBlock(), _createBlock(_component_v_card, {
                            key: x,
                            style: {"background-color":"white","border-radius":"25px","padding":"10px"},
                            class: "my-5"
                          }, {
                            default: _withCtx(() => [
                              (period.period === 'N')
                                ? (_openBlock(), _createBlock(_component_v_card_title, { key: 0 }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Solde " + _toDisplayString(period.period) + " : " + _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.totalBalance411NL, {
                                        currency: "",
                                        DC: true,
                                    })), 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : (_openBlock(), _createBlock(_component_v_card_title, { key: 1 }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Solde " + _toDisplayString(period.period) + " : " + _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.totalBalance411NLNextPeriod, {
                                        currency: "",
                                        DC: true,
                                    })), 1)
                                    ]),
                                    _: 2
                                  }, 1024)),
                              _createVNode(_component_v_card_text, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_GeneralLedger, {
                                            companyId: _ctx.companyId,
                                            accountingPeriodId: period.id,
                                            thirdPartyType: '411',
                                            inNm1: false,
                                            onQueryDone: period.onQueryDone,
                                            ref_for: true,
                                            ref: "generalLedger",
                                            enableAuditedAccountableAccounts: true
                                          }, null, 8, ["companyId", "accountingPeriodId", "onQueryDone"])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, _ctx.generalLedgerExpand411]
                    ])
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, _ctx.show411NL || _ctx.show411NLNextPeriod]
                ]),
                _createVNode(_component_v_card, {
                  elevation: "0",
                  style: {"background-color":"white","border-radius":"25px"},
                  class: "pa-6 mt-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "5",
                          class: "ma-auto"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                              default: _withCtx(() => [
                                (_ctx.auditItems.accountableAccountsRoot.length)
                                  ? (_openBlock(), _createElementBlock("h5", _hoisted_124, " Grand livre c/" + _toDisplayString(_ctx.getTextFromStringArray(_ctx.auditItems.accountableAccountsRoot)), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_col, {
                          cols: "1",
                          class: "d-flex align-center px-0 justify-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "align-center pa-0"
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "align-center pa-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn_icon, {
                                      icon: 
                                            _ctx.generalLedgerExpand
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        ,
                                      onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.generalLedgerExpand = !_ctx.generalLedgerExpand)),
                                      style: {"width":"40px"},
                                      class: "d-inline px-2",
                                      size: "x-small"
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _withDirectives(_createVNode(_component_v_card_text, { transition: "expand" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.periods, (period, y) => {
                          return (_openBlock(), _createBlock(_component_v_card, {
                            key: y,
                            style: {"background-color":"white","border-radius":"25px","padding":"10px"},
                            class: "my-5"
                          }, {
                            default: _withCtx(() => [
                              (period.period === 'N')
                                ? (_openBlock(), _createBlock(_component_v_card_title, { key: 0 }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Solde " + _toDisplayString(period.period) + " : " + _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.totalBalance4198NL, {
                                        currency: "",
                                        DC: true,
                                    })), 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : (_openBlock(), _createBlock(_component_v_card_title, { key: 1 }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Solde " + _toDisplayString(period.period) + " : " + _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.totalBalance4198NLNextPeriod, {
                                        currency: "",
                                        DC: true,
                                    })), 1)
                                    ]),
                                    _: 2
                                  }, 1024)),
                              _createVNode(_component_v_card_text, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_GeneralLedger, {
                                            companyId: _ctx.companyId,
                                            accountingPeriodId: period.id,
                                            accountableAccountFilter: 
                                                _ctx.auditItems.accountableAccountsRoot
                                            ,
                                            inNm1: false,
                                            onQueryDone: period.onQueryDone2
                                          }, null, 8, ["companyId", "accountingPeriodId", "accountableAccountFilter", "onQueryDone"])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_row, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, { style: {"padding-bottom":"0"} }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_card_title, { style: {"padding-top":"20px","padding-bottom":"0","padding-left":"0"} }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_spacer),
                                              (_ctx.closedPeriod)
                                                ? (_openBlock(), _createBlock(_component_v_btn, {
                                                    key: 0,
                                                    rounded: "",
                                                    disabled: "",
                                                    size: "x-small"
                                                  }, {
                                                    default: _withCtx(() => _cache[112] || (_cache[112] = [
                                                      _createTextVNode(" OD ")
                                                    ])),
                                                    _: 1
                                                  }))
                                                : (_openBlock(), _createBlock(_component_v_btn, {
                                                    key: 1,
                                                    rounded: "",
                                                    class: "btn btn_blue",
                                                    onClick: _cache[38] || (_cache[38] = ($event: any) => {
                                                    _ctx.createAdjustmentsData();
                                                    _ctx.miscellanousOperationData = undefined;
                                                    _ctx.miscellaneousOperationDialog = true;
                                                }),
                                                    size: "x-small"
                                                  }, {
                                                    default: _withCtx(() => _cache[113] || (_cache[113] = [
                                                      _createTextVNode(" OD ")
                                                    ])),
                                                    _: 1
                                                  }))
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, 1024),
                              _cache[114] || (_cache[114] = _createElementVNode("br", null, null, -1))
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, _ctx.generalLedgerExpand]
                    ])
                  ]),
                  _: 1
                }),
                (_ctx.displayActivityDialog)
                  ? (_openBlock(), _createBlock(_component_oss_dialog, {
                      key: 9,
                      modelValue: _ctx.displayActivityDialog,
                      "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.displayActivityDialog) = $event)),
                      title: "Activité",
                      "valid-title": "Fermer",
                      "min-width": "60vw",
                      onValid: _cache[40] || (_cache[40] = ($event: any) => (_ctx.displayActivityDialog = false)),
                      onClose: _cache[41] || (_cache[41] = ($event: any) => (_ctx.displayActivityDialog = false))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_UsersActivitiesHistory, {
                          auditCheckKey: _ctx.acKey,
                          accountingPeriodId: _ctx.accountingPeriodId
                        }, null, 8, ["auditCheckKey", "accountingPeriodId"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]))
                  : _createCommentVNode("", true),
                (_ctx.openChat)
                  ? (_openBlock(), _createBlock(_component_Chat, {
                      key: 10,
                      auditCheckAccountingPeriodKey: _ctx.chatId,
                      chatTitle: 'Chat'
                    }, null, 8, ["auditCheckAccountingPeriodKey"]))
                  : _createCommentVNode("", true),
                (_ctx.dialogAuditCheckDocumentsManager)
                  ? (_openBlock(), _createBlock(_component_AuditCheckDocumentsManager, {
                      key: 11,
                      modelValue: _ctx.dialogAuditCheckDocumentsManager,
                      "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.dialogAuditCheckDocumentsManager) = $event)),
                      disabled: _ctx.loading || _ctx.dataLoading || !_ctx.accountingPeriod,
                      companyId: _ctx.companyId,
                      documentToDisplay: _ctx.documentToDisplay,
                      connectedDocuments: _ctx.connectedDocuments || [],
                      acKey: _ctx.acKey,
                      auditCheckResult: _ctx.auditCheckResult || {},
                      accountingPeriodId: _ctx.accountingPeriodId || undefined,
                      alreadyLinkedDoc: _ctx.alreadyLinkedDoc,
                      onUpsertedAuditCheckResult: _ctx.upsertedACR,
                      onResetDialogData: _cache[43] || (_cache[43] = ($event: any) => {
                        _ctx.alreadyLinkedDoc = false;
                        _ctx.documentToDisplay = {};
                    })
                    }, null, 8, ["modelValue", "disabled", "companyId", "documentToDisplay", "connectedDocuments", "acKey", "auditCheckResult", "accountingPeriodId", "alreadyLinkedDoc", "onUpsertedAuditCheckResult"]))
                  : _createCommentVNode("", true)
              ], 64))
      ])
    ]),
    _: 1
  }))
}